"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_POLLING_INTERVALS = void 0;
exports.DEFAULT_POLLING_INTERVALS = {
    disbursement_list_ms: 10000,
    disbursement_statistics_ms: 10000,
    queue_status_ms: 10000,
    ussd_queue_stats_ms: 5000,
    ussd_modem_status_ms: 5000,
    ussd_configs_ms: 30000,
    ussd_error_logs_ms: 30000,
};
